<template>
  <div>
    <CustomFdkAccount v-slot="accountsData">
      <JdsButton
        v-if="!config.upvote?.hidden"
        variant="tertiary"
        size="small"
        @click="updateVoteCount(accountsData, 'upvote')"
        className="sm:!fe-text-body-xxs-bold"
      >
        <template #icon>
          <JdsIcon
            name="UpvoteIcon"
            smSize="s"
            lgSize="m"
            :color="
              upvoteSelected ? 'fe-text-success-50' : 'fe-text-primary-grey-80'
            "
          />
        </template>
        <span class="fe-text-primary-grey-80 fe-pl-xs"> Helpful </span>
        <span
          v-if="reviewObj.upvoteCount"
          class="fe-text-primary-grey-80 fe-pl-xs"
        >
          {{ getFormattedNumber(reviewObj.upvoteCount) }}
        </span>
      </JdsButton>

      <JdsButton
        v-if="!config.downvote?.hidden"
        variant="tertiary"
        size="small"
        @click="updateVoteCount(accountsData, 'downvote')"
        className="sm:!fe-text-body-xxs"
      >
        <template #icon>
          <JdsIcon
            name="DownvoteIcon"
            smSize="s"
            lgSize="m"
            :color="
              downvoteSelected ? 'fe-text-error-50' : 'fe-text-primary-grey-80'
            "
          />
          <span
            v-if="reviewObj.downvoteCount"
            class="fe-text-primary-grey-80 fe-pl-xs"
          >
            {{ getFormattedNumber(reviewObj.downvoteCount) }}
          </span>
        </template>
      </JdsButton>
    </CustomFdkAccount>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import CustomFdkAccount from "@/components/Utilities/CustomFdkAccount/CustomFdkAccount.vue"
  import { apiUpdateVoteCount } from "@/api_service/customerApi"
  import { customerLoginHandler, formatToReadableNumber } from "@/utils/utils"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"

  export default {
    name: "ReviewVote",
    components: { CustomFdkAccount, JdsButton, JdsIcon },
    inject: ["globalState"], // top parent component state
    props: {
      review: {
        type: Object,
        default: () => {},
        required: true,
      },
    },
    data() {
      return {
        upvoteSelected: false,
        downvoteSelected: false,
        reviewObj: this.review,
      }
    },
    computed: {
      config() {
        return this.globalState.widgetConfig?.layout
      },
    },
    methods: {
      async updateVoteCount(accountsData, voteType) {
        try {
          if (!accountsData.is_logged_in) {
            customerLoginHandler(accountsData)
            return
          }

          // User can upvote/downvote only once in one browser session, so using this flag
          if (
            (voteType === "upvote" && this.upvoteSelected) ||
            (voteType === "downvote" && this.downvoteSelected)
          ) {
            return
          }

          const queryParam = {
            contentId: this.reviewObj.id,
            vote: voteType.toUpperCase(),
          }

          const response = await apiUpdateVoteCount(queryParam)

          if (response.resultInfo.status === "SUCCESS") {
            if (voteType === "upvote") {
              this.reviewObj.upvoteCount =
                parseInt(this.reviewObj.upvoteCount) + 1

              if (this.downvoteSelected) {
                this.reviewObj.downvoteCount = this.reviewObj.downvoteCount - 1
                this.downvoteSelected = false
              }
              this.upvoteSelected = true
            } else {
              this.reviewObj.downvoteCount =
                parseInt(this.reviewObj.downvoteCount) + 1

              if (this.upvoteSelected) {
                this.reviewObj.upvoteCount = this.reviewObj.upvoteCount - 1
                this.upvoteSelected = false
              }
              this.downvoteSelected = true
            }
          }
        } catch (err) {
          console.error(err)
        }
      },
      getFormattedNumber(count) {
        if (!count) {
          return 0
        }
        return formatToReadableNumber(count)
      },
    },
  }
</script>
